import { useState } from "react";
import { Headphones, Sparkles } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import LearnReadingListening from "./LearnReadingListening";
import LearnSightVocabulary from "./LearnSightVocabulary";

/**
 * Learn shell — two tabs: Reading & Listening, and Sight Vocabulary.
 */
export default function LearnMode({ module: m, hasSections, selectedSection }) {
  const { t } = useI18n();
  const [tab, setTab] = useState("reading_listening"); // "reading_listening" | "sight_vocabulary"

  return (
    <>
      <div className="rounded-2xl bg-white border border-[#E7E0D2] p-2 flex items-center gap-2" data-testid="learn-tabs">
        <button
          data-testid="learn-tab-reading-listening"
          onClick={() => setTab("reading_listening")}
          className={`flex-1 inline-flex items-center justify-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium transition ${
            tab === "reading_listening" ? "bg-[#ECFDF5] text-[#064E3B] border border-[#A7F3D0]" : "text-[#4B5563] hover:text-[#1F2937] border border-transparent"
          }`}>
          <Headphones className="w-4 h-4" /> {t("rd.learn_tab_reading_listening")}
        </button>
        <button
          data-testid="learn-tab-sight-vocabulary"
          onClick={() => setTab("sight_vocabulary")}
          className={`flex-1 inline-flex items-center justify-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium transition ${
            tab === "sight_vocabulary" ? "bg-[#ECFDF5] text-[#064E3B] border border-[#A7F3D0]" : "text-[#4B5563] hover:text-[#1F2937] border border-transparent"
          }`}>
          <Sparkles className="w-4 h-4" /> {t("rd.learn_tab_sight_vocabulary")}
        </button>
      </div>

      <div className="mt-4">
        {tab === "reading_listening"
          ? <LearnReadingListening module={m} hasSections={hasSections} selectedSection={selectedSection} />
          : <LearnSightVocabulary module={m} hasSections={hasSections} selectedSection={selectedSection} />}
      </div>
    </>
  );
}
